import React from 'react'
import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const filters: App.OfferListFilters = {
  isCruiseTour: true,
  cruiseShips: [
    'MS Spitsbergen',
    'MS Roald Amundsen',
    'MS Santa Cruz II',
    'MS Fram',
    'MS Fridtjof Nansen',
    'Celebrity Xpedition',
    'Celebrity Flora',
    'Seabourn Venture',
    'Seabourn Pursuit',
  ],
}

function CruisePageExpeditionCruisesCarousel() {
  const intl = useIntl()
  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const viewAllLabel = intl.formatMessage({
    id: 'Ch4fFy49Oi',
    defaultMessage: 'View all',
    description: 'Button text to view all expedition cruise offers',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="JeVVStCihr"
            defaultMessage="Expedition <i>cruises</i>"
            description="Section heading for expedition cruise offers"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          {viewAllLabel}
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageExpeditionCruisesCarousel
